import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../../../actions/user.actions";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Button,
  Input,
} from "reactstrap";
import axiosInstance from '../../../helpers/axios';
import credit5 from "../../../assets/images/Credit5.png";
import debit5 from "../../../assets/images/debit5.png";
import download from "../../../assets/images/download.png";
import uploadPdf from "../../../assets/images/uploadPdf.svg";
import uploadZip from "../../../assets/images/uploadZip.svg";
import frame from "../../../assets/images/Frame.png";
import averageEod from "../../../assets/images/averageEod.png";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import loans from "../../../assets/images/loans.png";
import {
  Chart as ChartJS,
  LinearScale,
  ArcElement,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Chart, Bar } from "react-chartjs-2";
import "./index.css";
import BsiIntelligence from "./BsiIntelligence/BsiIntelligence";
import LoanRecyclingCard from "./LoanRecyclingCard/LoanRecyclingCard";
import LoanRecyclingErrorBoundary from "./LoanRecyclingCard/LoanRecyclingErrorBoundary";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import reset from "../../../assets/images/reset.png";
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import FraudCheck from "./AACards/FraudCheck";
import { SourceChip } from "./AACards/AnalyticsSource";
ChartJS.register(
  ArcElement,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);

export default function AccountAggregator({
  appId,
  userId,
  profileDetails, foirRefData,
  shouldFetchData = true,
  isCoapplicant = false
}) {
  const [pdfUploadStatus, setPdfUploadStatus] = useState("");
  const navigate = useNavigate()
  const decode = useCurrentUser();
  const user = null;
  const dispatch = useDispatch();
  const uploadState = useSelector(
    (state) => state?.POSTINCOMEPDF?.postIncomePdfData?.res?.data?.data
  );

  const getFoirState = useSelector(
    (state) => state?.GETFOIRDETAILS?.getFoirDetails
  );
  const { status: applicationStatus } = useSelector(state => state.appContext);

  const [openRemarks, setOpenAddRemarks] = useState(false);
  const [remarks, setRemarks] = useState(null);
  const [income, setIncome] = useState(null);
  const [rent, setRent] = useState(null);
  const [emi, setEmi] = useState(null);
  const [courseFeesFoir, setCourseFeesFoir] = useState(null);
  const [tenureFoir, setTenureFoir] = useState(null);
  const [feemonkEmi, setFeemonkEmi] = useState(null);
  const [openAddFoir, setOpenAddFoir] = useState(false);
  const [maxEmiAmount, setMaxEmiAmount] = useState("");
  const [minEmiAmount, setMinEmiAmount] = useState("");

  const [loanLimitMode, setLoanLimitMode] = useState(1); // 1 = Direct, 2 = Range
  const [directLoanAmount, setDirectLoanAmount] = useState("");
  const [directTenure, setDirectTenure] = useState("");
  const [isSubmittingLoanLimit, setIsSubmittingLoanLimit] = useState(false);
  const [rangePreviewStatus, setRangePreviewStatus] = useState("idle"); // idle | loading | success | error
  const [rangePreviewOptions, setRangePreviewOptions] = useState([]);
  const [rangePreviewError, setRangePreviewError] = useState("");
  const rangeRequestIdRef = React.useRef(0);
  const [accountAggregatorDetails, setAccountAggregatorDetails] = useState([])
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [accountOptions, setAccountOptions] = useState([]);
  const [loading,setLoading] = useState(false)
  const getFoirRefUrl = `admin/application/additional-info?applicationId=${appId}`;

  const urlIncomeProfile = `/bank-statement-analysis/finbox/admin-analytics-data?userId=${userId}&applicationId=${appId}`;


  const accountAggregatorUrl = `/account-aggregator/admin-analytics-data/${userId}?applicationId=${appId}`
  const getSanctionEmiFoirRefUrl = `admin/application/sanction-emi?applicationId=${appId}`;

  React.useEffect(() => {
    if (!isCoapplicant && applicationStatus !== "In Review" && applicationStatus !== "In Submission") {
      const feemonkEmiFetch = async () => {
        const feemonkEmiFetched = await feemonkEMiFromSanctionDetailsApi();
        setFeemonkEmi(feemonkEmiFetched);

      }
      feemonkEmiFetch()

    }
  }, [isCoapplicant, applicationStatus]);

  useEffect(() => {

    const controller = new AbortController();

    const fetchData = async () => {
      if (!shouldFetchData) return;  
      setLoading(true);
      try {
        const [accountAggregatorResponse] = await Promise.all([
          axiosInstance.get(accountAggregatorUrl, {
            signal: controller.signal,
          }),
        ]);
        setAccountAggregatorDetails(accountAggregatorResponse?.data?.data)
        // setAccountAggregatorDetails(accountAggregatorResponseData);
        setLoading(false)
      } catch (err) {
        if (err.name !== 'CanceledError') {
          console.error("Failed to fetch data:", err);
        }setLoading(false)
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };

  }, [user, urlIncomeProfile, shouldFetchData]);

  const feemonkEMiFromSanctionDetailsApi = async () => {
    try {
      const res = await axiosInstance.get(getSanctionEmiFoirRefUrl, {
        headers: {
        },
      });
      const fetchedEmi = res?.data?.data?.emi
      // Update state
      return fetchedEmi; // Return value for further use
    } catch (error) {
      return 0; // Return 0 as fallback
    }
  };



  //upload pdf
  const ref = React.useRef(null);
  const handleOpenUpload = () => {
    ref.current.click();
  };

  const [pdf, setPdf] = useState(null);

  const [openModal, setOpenModal] = React.useState(null);
  const [modalType, setModalType] = React.useState(null);

  const [pdfPassword, setPdfPassword] = React.useState("");
  const [zipPassword, setZipPassword] = React.useState("");

  const handleUploadPdf = (event) => {
    setPdf(event.target.files[0]);
  };
  const [openLoanLimit, setOpenLoanLimit] = useState(false);
  const handleCloseLoanLimit = () => {
    setMaxEmiAmount(null)
    setMinEmiAmount(null)
    setLoanLimitMode(1);
    setDirectLoanAmount("");
    setDirectTenure("");
    setRangePreviewStatus("idle");
    setRangePreviewOptions([]);
    setRangePreviewError("");
    setOpenLoanLimit(!openLoanLimit);
  };

  useEffect(() => {
    if (profileDetails) {
      setMaxEmiAmount(profileDetails.maximumEmiAmount ?? "");
      setMinEmiAmount(profileDetails.minimumEmiAmount ?? "");
    }
  }, [profileDetails]);

  // Range-mode preview: debounce ~500ms after both EMI bounds are valid, then
  // fetch amount/tenure options. A request id guards against a stale response
  // (from rapid typing or mode switching) overwriting a newer one.
  useEffect(() => {
    if (!openLoanLimit || loanLimitMode !== 2) {
      return;
    }

    const minVal = parseFloat(minEmiAmount);
    const maxVal = parseFloat(maxEmiAmount);
    const hasBothValues = minEmiAmount !== "" && minEmiAmount != null && maxEmiAmount !== "" && maxEmiAmount != null;
    const isValidRange = hasBothValues && !isNaN(minVal) && !isNaN(maxVal) && minVal > 0 && maxVal > 0 && maxVal >= minVal;

    if (!isValidRange) {
      rangeRequestIdRef.current += 1; // invalidate any in-flight fetch
      setRangePreviewStatus("idle");
      setRangePreviewOptions([]);
      setRangePreviewError(hasBothValues && maxVal < minVal ? "Maximum EMI must be greater than or equal to Minimum EMI" : "");
      return;
    }

    setRangePreviewStatus("loading");
    setRangePreviewError("");

    const requestId = ++rangeRequestIdRef.current;
    const timer = setTimeout(() => {
      const url = process.env.REACT_APP_BASE_URL + `/admin/application/loan-amount-for-emis?userId=${userId}&applicationId=${appId}&minEmi=${minVal}&maxEmi=${maxVal}`;
      axiosInstance
        .get(url)
        .then((res) => {
          if (rangeRequestIdRef.current !== requestId) return; // stale response, ignore
          const data = res?.data?.data;
          const options = data?.options || [];
          if (res?.data?.message !== "Successful" || data?.showSlider === false || options.length === 0) {
            setRangePreviewStatus("error");
            setRangePreviewOptions([]);
            setRangePreviewError("No loan options available for this EMI range.");
            return;
          }
          setRangePreviewOptions(options);
          setRangePreviewStatus("success");
        })
        .catch(() => {
          if (rangeRequestIdRef.current !== requestId) return;
          setRangePreviewStatus("error");
          setRangePreviewOptions([]);
          setRangePreviewError("Failed to fetch loan options. Please try again.");
        });
    }, 500);

    return () => clearTimeout(timer);
  }, [minEmiAmount, maxEmiAmount, loanLimitMode, openLoanLimit, userId, appId]);

  // Shared submit call for both loan-limit modes. Range-mode payload is not
  // yet finalized on the backend — swap this URL/body once it is, everything
  // else (validation, disabled state, reload) stays the same.
  const LOAN_LIMIT_SUBMIT_URL = "/admin/application/loan-amount";
  const submitLoanLimit = (payload) => axiosInstance.post(LOAN_LIMIT_SUBMIT_URL, null, { params: payload });

  const handleSubmitLoanLimitDirect = () => {
    const loanAmountVal = parseFloat(directLoanAmount);
    const tenureVal = parseFloat(directTenure);
    if (
      !directLoanAmount ||
      !directTenure ||
      isNaN(loanAmountVal) ||
      isNaN(tenureVal) ||
      loanAmountVal <= 0 ||
      tenureVal <= 0
    ) {
      alert("Enter a valid Loan Amount and Tenure");
      return;
    }

    setIsSubmittingLoanLimit(true);
    submitLoanLimit({
      applicationId: appId,
      userId: userId,
      loanAmount: loanAmountVal,
      tenure: tenureVal,
      loanAmountMode: 1,
    })
      .then((res) => {
        if (res?.data?.message === "Successful") {
          alert("Updated Succesfully");
          window.location.reload();
        }
      })
      .catch(() => {
        alert("Error Updating");
      })
      .finally(() => setIsSubmittingLoanLimit(false));
  };

  const handleSubmitLoanLimitRange = () => {
    if (rangePreviewStatus !== "success") return;

    setIsSubmittingLoanLimit(true);
    submitLoanLimit({
      minimumEmiAmount: parseFloat(minEmiAmount),
      maximumEmiAmount: parseFloat(maxEmiAmount),
      applicationId: appId,
      loanAmountMode: 2
    })
      .then((res) => {
        if (res?.data?.message === "Successful") {
          alert("Updated Succesfully");
          window.location.reload();
        }
      })
      .catch(() => {
        alert("Error Updating");
      })
      .finally(() => setIsSubmittingLoanLimit(false));
  };

  const handlePdfFormSubmit = () => {
    const urlPostIncomePdf = "/bank-statement-analysis/finbox/upload";

    const data = new FormData();
    data.append("file", pdf);
    data.append("type", "pdf");
    data.append("userId", userId);
    data.append("password", pdfPassword);
    data.append("applicationId", appId);
    data.append("Feemonk", "source");
    dispatch(userActions.postIncomePdf(urlPostIncomePdf, data, user));
    setOpenModal(false);
    setPdfPassword("");

    setTimeout(() => {
      window.location.reload()


    }, 1000);
  };

  const handleZipFormSubmit = () => {
    const urlPostIncomePdf = "/bank-statement-analysis/upload/zip";

    const data = new FormData();
    data.append("file", pdf);
    data.append("type", "pdf");
    data.append("userId", userId);
    data.append("password", pdfPassword);
    data.append("zipPassword", zipPassword);

    dispatch(userActions.postIncomePdf(urlPostIncomePdf, data, user));
    setOpenModal(false);
    setPdfPassword("");
    setZipPassword("");
  };

  useEffect(() => {
    if (Array.isArray(accountAggregatorDetails?.analyticsData)) {
      const opts = accountAggregatorDetails?.analyticsData?.map((a) => ({
          label: `${a?.accountNumber} - ${a?.bank}`,
          value: a?.accountNumber,
        }));
      setAccountOptions(opts);
      if (opts?.length > 0 && !selectedAccount) setSelectedAccount(opts[0]?.value);
    } else {
      setAccountOptions([]);
      setSelectedAccount(null);
    }
  }, [accountAggregatorDetails]);

  const displayData = Array.isArray(accountAggregatorDetails?.analyticsData)
    ? (selectedAccount
        ? accountAggregatorDetails?.analyticsData.find((a) => a?.accountNumber === selectedAccount)
        : accountAggregatorDetails[0])
    : accountAggregatorDetails || {};
  const hasAnalytics = !!(accountAggregatorDetails?.analyticsData || accountAggregatorDetails?.analysisExcelReport);

  const lastThreeEmiTransactions = displayData?.emiTransactions ? displayData?.emiTransactions.filter((r) => r?.dateOfTransaction === "Total").slice(-3) : [];

  let labelsEOD = [];

  displayData?.avgEODBal?.map((item, idx) => {
    labelsEOD.push(item);
  });
  const optionsVerticalBar = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: true,
    animation: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "Average EOD",
      },
    },
  }), []);

  function getMonth(monthNumber) {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr',
      'May', 'Jun', 'Jul', 'Aug',
      'Sep', 'Oct', 'Nov', 'Dec'
    ];

    return months[monthNumber - 1];
  }

  let labels = [];
  displayData?.eod?.map((item) => {
    const month = getMonth(item?.month);
    labels.push(`${month} / ${item.year}`);
  });

  const dataVertical = useMemo(() => ({
    labels,
    datasets: [
      {
        data: displayData?.eod?.map((item) => (item?.averageBalance)),
        backgroundColor: (color) => {
          let colors = color.raw > (((feemonkEmi || feemonkEmi == 0) ? feemonkEmi : Math.round((profileDetails?.courseFees / profileDetails?.loanTenure) * 100) / 100)) ? "#23BDC0" : "red";
          return colors;
        },
        borderWidth: 1,
      },
    ],
  }), [displayData?.eod, feemonkEmi, profileDetails?.courseFees, profileDetails?.loanTenure]);

  let summaryData = [];
  let cashDepositsSum = 0;
  for (let i = 0; i < (displayData?.summary?.cashDeposits?.length || 0); i++) {
    cashDepositsSum += displayData?.summary?.cashDeposits[i]?.amount
  }
  summaryData.push(cashDepositsSum)

  let salaryCreditSum = 0;
  for (let i = 0; i < (displayData?.summary?.salaryCredits?.length || 0); i++) {
    salaryCreditSum += displayData?.summary?.salaryCredits[i]?.amount
  }
  summaryData.push(salaryCreditSum)

  let loanCreditsSum = 0;
  for (let i = 0; i < (displayData?.summary?.loanCredits?.length || 0); i++) {
    loanCreditsSum += displayData?.summary?.loanCredits[i]?.emiAmount
  }
  summaryData.push(loanCreditsSum)

  let chequeDepositsSum = 0;
  for (let i = 0; i < (displayData?.summary?.chequeDeposits?.length || 0); i++) {
    chequeDepositsSum += displayData?.summary?.chequeDeposits[i]?.amount
  }
  summaryData.push(chequeDepositsSum)


  const dataDoughnut = {
    labels: [
      "Cash Deposits",
      "Cheque Deposits",
      "Loan Credits",
      "Salary Credits",
    ],

    datasets: [
      {
        label: "Amount",
        data: [displayData?.summary?.cashDeposits?.reduce((sum, item) => sum + (item?.amount || 0), 0) || 0,
        displayData?.summary?.chequeDeposits?.reduce((sum, item) => sum + (item?.amount || 0), 0) || 0,
        displayData?.summary?.loanCredits?.reduce((sum, item) => sum + (item?.amount || 0), 0) || 0,
        displayData?.summary?.salaryCredits?.reduce((sum, item) => sum + (item?.amount || 0), 0) || 0],
        backgroundColor: ["#579AFD", "#FA4B53", "#FE825B", "#23BDC0"],

        borderWidth: 1,
      },
    ],
  };

  const options = {
    maintainAspectRatio: true,

    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 1,
      },
    },
    responsive: true,
    plugins: {
      title: {
        display: true,
      },
    },
  };

  let footerCredit = [];
  displayData?.top5Credit?.map((item) => {
    footerCredit.push(`${item.paymentMode} - ${item.subcategory}`);
  });
  let footerDebit = [];
  displayData?.top5Debit?.map((item) => {
    footerDebit.push(`${item.paymentMode} - ${item.subcategory}`);
  });

  const optionsDebit = {
    maintainAspectRatio: true,

    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 1,
      },
    },
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          beforeTitle: function (context) {
            return `${footerDebit[context[0].dataIndex]}`;
          },
        },
      },
      title: {
        display: true,
      },
    },
  };
  const optionsCredit = {
    maintainAspectRatio: true,

    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 1,
      },
    },
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          beforeTitle: function (context) {
            return `${footerCredit[context[0].dataIndex]}`;
          },
        },
      },
      title: {
        display: true,
      },
    },
  };
  const optionsFoir = {
    maintainAspectRatio: true,
    indexAxis: "x",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    scales: {
      B: {
        type: "linear",
        position: "right",
        ticks: { beginAtZero: true },
        grid: { display: false },
      },
      A: {
        position: "left",
        ticks: { beginAtZero: true },
        grid: { display: false },
      },
      x: { ticks: { beginAtZero: true } },
    },
    plugins: {
      legend: {
        position: "right",
      },
      title: {
        display: true,
      },
    },
  };

  let month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Helper: when a row has date === "Total", find a nearby real transaction
  // and return its month-year (e.g. "Jul 2025"). If not found, return empty string.
  const getMonthYearForTotalAA = (rows, idx, dateKey = 'dateOfTransaction') => {
    if (!Array.isArray(rows) || rows.length === 0) return "";

    // Prefer previous real transaction as base; advance months for consecutive totals
    for (let i = idx - 1; i >= 0; i--) {
      const d = rows[i] && rows[i][dateKey];
      if (d && d !== "Total" && d !== "Total Amount") {
        const baseStr = d;
        let baseDate = new Date(baseStr);
        if (isNaN(baseDate)) {
          const m = (baseStr || "").match(/(\d{4})-(\d{2})-(\d{2})/);
          if (m) baseDate = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, 1);
        }
        if (isNaN(baseDate)) return "";
        let offset = 0;
        for (let j = i + 1; j <= idx; j++) {
          const v = rows[j] && rows[j][dateKey];
          if (v === "Total" || v === "Total Amount") offset++;
        }
        const monthOffset = Math.max(0, offset - 1);
        const resultDate = new Date(baseDate.getFullYear(), baseDate.getMonth() + monthOffset, 1);
        return `${month[resultDate.getMonth()]} ${resultDate.getFullYear()}`;
      }
    }

    // Backfill from next real transaction if no previous found
    for (let i = idx + 1; i < rows.length; i++) {
      const d = rows[i] && rows[i][dateKey];
      if (d && d !== "Total" && d !== "Total Amount") {
        const baseStr = d;
        let baseDate = new Date(baseStr);
        if (isNaN(baseDate)) {
          const m = (baseStr || "").match(/(\d{4})-(\d{2})-(\d{2})/);
          if (m) baseDate = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, 1);
        }
        if (isNaN(baseDate)) return "";
        const dist = i - idx;
        const resultDate = new Date(baseDate.getFullYear(), baseDate.getMonth() - dist, 1);
        return `${month[resultDate.getMonth()]} ${resultDate.getFullYear()}`;
      }
    }

    return "";
  };

  const getDisplayDateAA = (row, idx, rows, dateKey = 'dateOfTransaction') => {
    if (!row) return "";
    const dval = row[dateKey];
    if (dval === "Total" || dval === "Total Amount") {
      const my = getMonthYearForTotalAA(rows, idx, dateKey);
      row.yearMonthForTotal = my ? my : ""; 
      return my ? my : "";
    }
    try {
      return new Date(dval).toLocaleDateString("en-GB");
    } catch (e) {
      return dval;
    }
  };

  let top5CreditLabels = [];
  displayData?.topCreditTransaction?.map((item) => {
    const month = getMonth(item?.month);
    top5CreditLabels.push(`${month} / ${item.year}`);
  });
  let top5Amount = [];
  displayData?.topCreditTransaction?.map((item) => {
    top5Amount.push(item?.amount);
  });

  const dataBarCredit = {
    labels: top5CreditLabels,
    datasets: [
      {
        label: "Amount",
        data: top5Amount,
        backgroundColor: "#23BDC0",
      },
    ],
  };
  let top5DebitLabels = [];
  displayData?.topDebitTransaction?.map((item) => {
    const month = getMonth(item?.month);
    top5DebitLabels.push(`${month} / ${item.year}`);
  });
  let top5DebitAmount = [];
  displayData?.topDebitTransaction?.map((item) => {
    top5DebitAmount.push(item?.amount);
  });

  const dataBarDebit = {
    labels: top5DebitLabels,
    datasets: [
      {
        label: "Amount",
        data: top5DebitAmount,
        backgroundColor: "#FE825B",
      },
    ],
  };

  const emiAll = displayData?.emiTransactions || [];
  const loanAll = displayData?.loanTransactions || [];
  const emiCount = emiAll.filter((r) => r?.dateOfTransaction !== "Total").length;
  const loanCount = loanAll.filter((r) => r?.dateOfTransaction !== "Total").length;

  let dataOutflow = [];
  displayData?.foir?.map((item) => {
    dataOutflow.push(item?.totalDebitAmount);
  });
  let dataInflow = [];
  displayData?.foir?.map((item) => {
    dataInflow.push(item?.totalCreditAmount);
  });
  let foirPercentage = [];

  if (dataOutflow.length === dataInflow.length) {

    for (let i = 0; i < dataOutflow.length; i++) {
      let ratio = dataOutflow[i] / dataInflow[i];
      foirPercentage.push(ratio);
    }
  } else {
    console.error("Arrays have different lengths. Unable to calculate ratios.");
  }
  const dataFoir = {
    labels,
    datasets: [
      {
        yAxisID: "B",

        type: "line",
        label: "Foir %",
        borderColor: "rgb(255, 99, 132)",
        borderWidth: 2,
        fill: false,
        data: foirPercentage,
      },
      {
        yAxisID: "A",
        type: "bar",
        label: "Outflow",
        backgroundColor: "#FE825B",
        data: dataOutflow,
        borderColor: "white",
        borderWidth: 2,
      },
      {
        yAxisID: "A",
        type: "bar",
        label: "Inflow",
        backgroundColor: "#23BDC0",
        data: dataInflow,
      },
    ],
  };
  const [checked, setChecked] = React.useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const postFoirRefUrl = "/admin/application/additional-info";
  const handleSubmitFoir = () => {
    const foirKey = document.getElementById("foirValue").value;
    if (foirKey && emi && income && rent) {
      const data = {
        applicationId: appId,
        userId: userId,
        emiPerMonth: emi ? emi : 0,
        incomePerMonth: income ? income : 0,
        rentPerMonth: rent ? rent : 0,
        foir: foirKey ? foirKey : 0,
      };

      dispatch(userActions.postFoirDetails(postFoirRefUrl, data, user));
      dispatch(userActions.getFoirDetails(getFoirRefUrl, user));
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);
      setOpenAddFoir(!openAddFoir);
    } else alert("Fill All Details");
  };

  const [excelPath, setExcelPath] = useState(null)
  const handleDownloadExcel = (path) => {
    const extractedPart = path.split(".com/")[1];
    const url = `/file/url-content?path=${extractedPart}`
    axiosInstance.get(url).then((res) => {
      setExcelPath(res?.data?.data)
    }).catch((error) => {  })
  }


  const handleCloseFoir = () => {
    document.getElementById("feemonkemi").value = 0;
    document.getElementById("foirValue").value = 0;
    setRent(null)
    setEmi(null)
    setIncome(null)

    setOpenAddFoir(!openAddFoir);
    setOpenAddRemarks(!openRemarks);
  };

  const handleChangeFMTenure = (e) => {
    document.getElementById("feemonkemi").value =
      Math.round(
        (profileDetails?.courseFees / e.target.value) * 100
      ) / 100;

    setFeemonkEmi(document.getElementById("feemonkemi").value);
  };

  const [recommendedEmiDate, setRecommendedEmiDate] = useState(null);

  const calculateRecommendedEmiDate = () => {
    const salaryDates = displayData?.salaryTransactions || [];

    if (salaryDates.length === 0) {
      setRecommendedEmiDate(null);
      return null;
    }

    const days = salaryDates.map(item => {
      const date = new Date(item.dateOfTransaction);
      return date.getDate();
    });

    const dayFrequency = {};
    days.forEach(day => {
      dayFrequency[day] = (dayFrequency[day] || 0) + 1;
    });

    const mostCommonDay = parseInt(
      Object.keys(dayFrequency).reduce((a, b) =>
        dayFrequency[a] > dayFrequency[b] ? a : b
      )
    );

    let emiDate;

    if (mostCommonDay >= 1 && mostCommonDay <= 3) {
      emiDate = 5;
    } else if (mostCommonDay >= 4 && mostCommonDay <= 8) {
      emiDate = 10;
    } else if (mostCommonDay >= 9 && mostCommonDay <= 13) {
      emiDate = 15;
    } else if (mostCommonDay >= 14 && mostCommonDay <= 18) {
      emiDate = 20;
    } else if (mostCommonDay >= 19 && mostCommonDay <= 23) {
      emiDate = 25;
    } else if (mostCommonDay >= 24 && mostCommonDay <= 31) {
      emiDate = 1;
    }

    setRecommendedEmiDate(emiDate);
    return emiDate;
  };

  function formatNumberWithCommas(number) {
    return number.toLocaleString('en-IN');
  }
  
  useEffect(() => {
    if (displayData?.salaryTransactions) {
      calculateRecommendedEmiDate();
    }
  }, [accountAggregatorDetails]);

  const [confirmationModal, setConfirmationModal] = useState(false)
  const [refreshConfirmationModal, setRefreshConfirmationModal] = useState(false)
  const toggleConfirmationModal = () => {
    setConfirmationModal(!confirmationModal)
  }

  const toggleRefreshConfirmationModal = () => {
    setRefreshConfirmationModal(!refreshConfirmationModal)
  }

  const handleReset = () => {
    const url = "/bank-sdk/reset"
    const body = {
      userId: userId,
      applicationId: appId
    }

    axiosInstance.post(url, body, {
      headers: {
      }
    })

      .then((res) => {
        if (res?.data?.message === "success") {
          alert("Reset Successful")
          window.location.reload()
        }
      })
      .catch((err) => {
        alert("error in resetting")
      })

  }

  const handleRefresh = () => {
    const url = `/bank-statement-analysis/finbox/refresh-session?userId=${userId}&applicationId=${appId}`
    axiosInstance.get(url, {
      headers: {
      }
    })

      .then((res) => {
        if (res?.data?.message === "success") {
          alert("Refresh Successful")
          window.location.reload()
        }
      })
      .catch((err) => {
        alert("error in refreshing")
      })

  }
  const salaryTransactions = displayData?.salaryTransactions || [];
  const salaryStats = React.useMemo(() => {
    if (!salaryTransactions || salaryTransactions.length === 0) {
      return { max: 0, min: 0, avg: 0, sum: 0, count: 0 };
    }
    const amounts = salaryTransactions
      .map((s) => Number(s?.amount || 0))
      .filter((a) => !isNaN(a));
    const count = amounts.length;
    const sum = amounts.reduce((a, b) => a + b, 0);
    const max = Math.max(...amounts);
    const min = Math.min(...amounts);
    const avg = count > 0 ? sum / count : 0;
    return { max, min, avg, sum, count };
  }, [displayData?.salaryTransactions]);

  return (
    <div style={{ display: "block" }}>
      <Modal isOpen={confirmationModal} toggle={toggleConfirmationModal} backdrop="static" style={{ top: '10%' }}>
        <ModalHeader toggle={toggleConfirmationModal}>Reset Statement(AA)</ModalHeader>
        <ModalBody>
          <p style={{ fontFamily: 'Inter-Medium', textAlign: 'center' }}> Are You Sure, Click <span style={{ fontFamily: 'Inter-Medium', fontWeight: 'bold' }}>OK</span> to continue.{" "}
          </p>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button style={{ backgroundColor: 'gray', color: 'white', paddingLeft: '10px', paddingRight: '10px', borderRadius: '10px' }} onClick={toggleConfirmationModal}> CANCEL</button>
            <button style={{ backgroundColor: '#d32808', color: 'white', paddingLeft: '10px', paddingRight: '10px', borderRadius: '10px' }} onClick={() => handleReset()}>OK</button>

          </div>
        </ModalBody>
      </Modal>
       <Modal isOpen={refreshConfirmationModal} toggle={toggleRefreshConfirmationModal} backdrop="static" style={{ top: '10%' }}>
        <ModalHeader toggle={toggleRefreshConfirmationModal}>Refresh Statement(AA)</ModalHeader>
        <ModalBody>
          <p style={{ fontFamily: 'Inter-Medium', textAlign: 'center' }}> Are You Sure, Click <span style={{ fontFamily: 'Inter-Medium', fontWeight: 'bold' }}>OK</span> to continue.{" "}
          </p>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button style={{ backgroundColor: 'gray', color: 'white', paddingLeft: '10px', paddingRight: '10px', borderRadius: '10px' }} onClick={toggleRefreshConfirmationModal}> CANCEL</button>
            <button style={{ backgroundColor: '#d32808', color: 'white', paddingLeft: '10px', paddingRight: '10px', borderRadius: '10px' }} onClick={() => handleRefresh()}>OK</button>

          </div>
        </ModalBody>
      </Modal>
      <Dialog
        style={{ marginTop: "-20%" }}
        fullWidth={true}
        open={openModal}
        onClose={setOpenModal}
      >
        <DialogTitle style={{ backgroundColor: "#F3F3F3" }}>
          Upload Files
        </DialogTitle>
        <DialogContent style={{ marginTop: "1em" }}>
          {/* <p>Upload {modalType === "PDF" ? "PDF File" : "Zip File"}</p> */}
          <div
            style={{
              marginBottom: "1rem",
            }}
          >
            <img
              onClick={() => handleOpenUpload()}
              style={{ cursor: "pointer" }}
              src={modalType === "PDF" ? uploadPdf : uploadZip}
            /> <small style={{ color: "green", fontWeight: 'bold' }}>{pdf ? " File Uploaded " : null}</small>
            <input
              onChange={(e) => handleUploadPdf(e)}
              ref={ref}
              style={{ display: "none" }}
              type="file"
            />
          </div>
          <Form>
            <FormGroup>
              {modalType === "ZIP" && (
                <>
                  Zip File Password
                  <Input
                    style={{ marginBottom: "1em" }}
                    onChange={(e) => setZipPassword(e.target.value)}
                    type="password"
                    placeholder="Zip File Password"
                    value={zipPassword}
                  />
                </>
              )}
              PDF File Password
              <Input
                style={{ marginBottom: "1em" }}
                onChange={(e) => setPdfPassword(e.target.value)}
                type="password"
                placeholder="PDF File Password"
                value={pdfPassword}
              />
            </FormGroup>
          </Form>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenModal(); setPdf(null) }}>Cancel</Button>
          <Button
            onClick={() => {
              if (modalType === "ZIP") {
                handleZipFormSubmit();
              } else {
                handlePdfFormSubmit();
              }
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Modal size="md" isOpen={openAddFoir}>
        <ModalHeader style={{ backgroundColor: "#F0F0F0" }}>
          <span style={{ fontWeight: "bold" }}>Add FOIR</span>
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              Income
              <Input
                style={{ marginBottom: "1em" }}
                onChange={(e) => setIncome(e.target.value)}
                type="number"
                placeholder="&#8377;"
              />
              Rent
              <Input
                style={{ marginBottom: "1em" }}
                onChange={(e) => setRent(e.target.value)}
                type="number"
                placeholder="&#8377;"
              />
              EMI
              <Input
                style={{ marginBottom: "1em" }}
                onChange={(e) => setEmi(e.target.value)}
                type="number"
                placeholder="&#8377;"
              />
              {applicationStatus === "In Review" && (<>
                <p>Tenure</p>
                <Input
                  defaultValue={profileDetails?.tenure}
                  style={{ marginBottom: "1em" }}
                  onChange={(e) => handleChangeFMTenure(e)}
                  type="number"

                /></>)}
              {/* <Input onChange={(e)=>handleChangeFMTenure(e)} type="number" placeholder="Tenure"/> */}
              Feemonk EMI
              {/* <Input onChange={(e)=>handleChangeFMCourse(e)} type="number" placeholder="Course Fees"/> */}
              <Input
                style={{ marginBottom: "1em" }}
                // defaultValue={
                //   (feemonkEmi || feemonkEmi == 0)?feemonkEmi:Math.round(
                //     (profileDetails?.courseFees / profileDetails?.loanTenure) *
                //       100
                //   ) / 100
                // }
                defaultValue={
                  (applicationStatus === "In Review" || applicationStatus === "In Submission") ? (Math.round(
                    (profileDetails?.courseFees / profileDetails?.loanTenure) *
                    100
                  ) / 100) : ((feemonkEmi || feemonkEmi == 0) ? feemonkEmi : 0)
                }
                id="feemonkemi"
                disabled
                type="number"
                placeholder="Feemonk EMI"
              />
              
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  backgroundColor: "#FCF0F1",
                  padding: "1em",
                  borderRadius: "10px",
                }}
              >
                <p style={{ color: "#d32028", marginTop: "10px" }}>
                  Calculated FOIR
                </p>
                <Input
                  style={{ width: "15em" }}
                  id="foirValue"
                  disabled
                  value={Math.round(
                    ((parseFloat(rent ? rent : 0) +
                      parseFloat(emi ? emi : 0) +
                      parseFloat((feemonkEmi || feemonkEmi == 0) ? feemonkEmi : 0)) /
                      parseFloat(income ? income : 0)) *
                    100
                  )}
                  type="number"
                  placeholder="Calculated FOIR"
                />
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => handleCloseFoir()}>Close Box</Button>
          <Button
            style={{ backgroundColor: "#d32028", border: "none" }}
            onClick={() => handleSubmitFoir()}
          >
            Submit
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="md" isOpen={openLoanLimit}>
        <ModalHeader style={{ backgroundColor: "#F0F0F0" }}>
          <span style={{ fontWeight: "bold" }}>Set Loan Limit</span>
        </ModalHeader>
        <ModalBody>
          <div style={{ display: "flex", marginBottom: "1.5em" }}>
            <Button
              onClick={() => setLoanLimitMode(1)}
              style={{
                flex: 1,
                marginRight: "0.5em",
                backgroundColor: loanLimitMode === 1 ? "#d32028" : "#FFF",
                color: loanLimitMode === 1 ? "#FFF" : "#000",
                border: "1px solid #d32028",
              }}
            >
              Direct
            </Button>
            <Button
              onClick={() => setLoanLimitMode(2)}
              style={{
                flex: 1,
                backgroundColor: loanLimitMode === 2 ? "#d32028" : "#FFF",
                color: loanLimitMode === 2 ? "#FFF" : "#000",
                border: "1px solid #d32028",
              }}
            >
              Range
            </Button>
          </div>

          {loanLimitMode === 1 ? (
            <Form>
              <FormGroup>
                Loan Amount
                <Input
                  style={{ marginBottom: "1em" }}
                  onChange={(e) => setDirectLoanAmount(e.target.value)}
                  type="number"
                  value={directLoanAmount}
                  placeholder="&#8377;"
                />
                Tenure (months)
                <Input
                  style={{ marginBottom: "1em" }}
                  onChange={(e) => setDirectTenure(e.target.value)}
                  type="number"
                  value={directTenure}
                  placeholder="Months"
                />
              </FormGroup>
            </Form>
          ) : (
            <Form>
              <FormGroup>
                Minimum EMI Amount
                <Input
                  style={{ marginBottom: "1em" }}
                  onChange={(e) => setMinEmiAmount(e.target.value)}
                  value={minEmiAmount}
                  type="number"
                  placeholder="&#8377;"
                />
                Maximum EMI Amount
                <Input
                  style={{ marginBottom: "1em" }}
                  onChange={(e) => setMaxEmiAmount(e.target.value)}
                  type="number"
                  value={maxEmiAmount}
                  placeholder="&#8377;"
                />
              </FormGroup>

              {rangePreviewStatus === "loading" && (
                <Box style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "2em" }}>
                  <CircularProgress size={28} />
                </Box>
              )}

              {rangePreviewStatus === "error" && (
                <p style={{ color: "red", textAlign: "center" }}>{rangePreviewError}</p>
              )}

              {rangePreviewStatus === "idle" && rangePreviewError && (
                <p style={{ color: "red", textAlign: "center" }}>{rangePreviewError}</p>
              )}

              {rangePreviewStatus === "success" && (
                <TableContainer component={Paper} style={{ marginTop: "1em" }}>
                  <Table size="small" aria-label="loan amount preview table">
                    <TableHead sx={{ backgroundColor: "#F6F9FF" }}>
                      <TableRow>
                        <TableCell>Loan Amount</TableCell>
                        <TableCell align="center">Eligible Tenures (months)</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rangePreviewOptions.map((option, idx) => (
                        <TableRow key={idx}>
                          <TableCell scope="row">&#8377;{option?.amount?.toLocaleString()}</TableCell>
                          <TableCell align="center">{(option?.tenures || []).map((t) => t?.tenure).join(", ")}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Form>
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => handleCloseLoanLimit()}>Close</Button>
          <Button
            style={{ backgroundColor: "#d32028", border: "none" }}
            disabled={
              isSubmittingLoanLimit ||
              (loanLimitMode === 2 && rangePreviewStatus !== "success")
            }
            onClick={() => (loanLimitMode === 1 ? handleSubmitLoanLimitDirect() : handleSubmitLoanLimitRange())}
          >
            {isSubmittingLoanLimit ? "Submitting" : "Submit"}
          </Button>
        </ModalFooter>
      </Modal>
      {!isCoapplicant && (
      <div
        style={{
          display: "flex",
          paddingTop: "1em",
          marginTop: "2em",
          justifyContent: "space-around",
          backgroundColor: "#FFF3F3",
          border: "1px solid #D32028",
          borderRadius: "1em",
        }}
      >
        <div style={{ display: "block", lineHeight: "1em" }}>
          <p>Current Rent</p>
          <p style={{ fontWeight: "bold" }}>
            &#8377;{foirRefData?.rentPerMonth?.toLocaleString()}
          </p>
        </div>
        <div style={{ display: "block", lineHeight: "1em" }}>
          <p>Current Income</p>
          <p style={{ fontWeight: "bold" }}>
            &#8377;{foirRefData?.incomePerMonth?.toLocaleString()}
          </p>
        </div>
        <div style={{ display: "block", lineHeight: "1em" }}>
          <p>Current EMI</p>
          <p style={{ fontWeight: "bold" }}>
            &#8377;{foirRefData?.emiPerMonth?.toLocaleString()}
          </p>
        </div>
      
        <div style={{ display: "block", lineHeight: "1em" }}>
          <p>{decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "Bijay EMI" : "Feemonk EMI"}</p> 
          <p style={{ fontWeight: "bold" }}>
            &#8377;
            {/* {feemonkEmi?.toLocaleString()?feemonkEmi
              : Math.round(
                  (profileDetails?.courseFees / profileDetails?.loanTenure) *
                    100
                ) / 100}  */}
            {/* {(feemonkEmi || feemonkEmi == 0)&&feemonkEmi.toLocaleString()
              } */}
            {
              (applicationStatus === "In Review" || applicationStatus === "In Submission") ? (Math.round(
                (profileDetails?.courseFees / profileDetails?.loanTenure) *
                100
              ) / 100) : ((feemonkEmi || feemonkEmi == 0) ? feemonkEmi : 0)
            }
          </p>
        </div>
        <div style={{ display: "block", lineHeight: "1em" }}>
          <p>FOIR</p>
          <p style={{ fontWeight: "bold" }}>{foirRefData?.foir} %</p>
        </div>

        <div style={{ display: "block", lineHeight: "1em" }}>
          <Button
            onClick={() => setOpenAddFoir(!openAddFoir)}
            style={{ backgroundColor: "#D32028", border: "none" }}
          >
            Edit FOIR
          </Button>
        </div>
        {profileDetails?.cra === "app" ? <><div style={{ display: "block", lineHeight: "1em" }}>
          <Button
            onClick={() => setOpenLoanLimit(!openLoanLimit)}
            style={{ backgroundColor: "#D32028", border: "none" }}
          >
            Set Limits
          </Button>
        </div></> : null}

      </div>
      )}
      {loading ?(
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15%' }}>
            <CircularProgress />
        </Box>
      ):(
        <>
        <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "1em",
        }}
      >
        <div

        >
          <span
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              fontFamily: "Outfit",
              color: !checked ? "#D32028" : "#B0B0B0",
            }}
          >
            Account Aggregator {profileDetails?.cra === "app" ? <span onClick={() => toggleConfirmationModal()}><img src={reset} style={{ height: '30px', marginLeft: '10px', cursor: 'pointer' }} /></span> :  
            <Button onClick={() => toggleRefreshConfirmationModal()} style={{ fontFamily: 'Inter-Medium',backgroundColor:"#D32028", color: 'white', marginLeft: '5px' }}>Refresh</Button>}
            {hasAnalytics ? <SourceChip source={accountAggregatorDetails?.source} /> : null}
          </span>

        </div>

        {recommendedEmiDate ? <Button style={{ fontSize: '13px', backgroundColor: '#FFF', border: '1px solid #DbDbDb', color: 'black', fontWeight: 'bold', marginRight: '10%' }}>Recommended EMI Date : <strong style={{ color: 'green' }}> {recommendedEmiDate} of every month</strong></Button> : null}
        {displayData?.nameMatchScore ? <Button style={{ fontSize: '13px', backgroundColor: '#FFF', border: '1px solid #DbDbDb', color: 'black', fontWeight: 'bold', marginRight: '10%' }}>NameMatch Score : <strong>{Number(displayData?.nameMatchScore)?.toFixed(2)}%</strong></Button> : null}
        {accountOptions?.length > 0 && (
          <div style={{ marginRight: '1rem' }}>
            <select value={selectedAccount || ""} onChange={(e) => setSelectedAccount(e.target.value)} style={{ padding: '6px', borderRadius: '6px', width: '220px' }}>
              <option value="">Select account</option>
              {accountOptions.map((opt, i) => (
                <option key={i} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
        )}
        <div
          style={{
            display: "flex", backgroundColor: '#D22129', borderRadius: '8px', paddingLeft: '5px', paddingRight: '5px'
          }}
        >
          <a href={excelPath} target="_blank" style={{ display: 'flex', cursor: 'pointer', textDecoration: 'none' }} onClick={() => handleDownloadExcel(Array.isArray(accountAggregatorDetails?.analyticsData) ? accountAggregatorDetails?.analysisExcelReport : displayData?.analysisExcelReport)} rel="noreferrer">            <img
            style={{ cursor: "pointer", height: '16px', width: '16px', marginTop: '0.7rem' }}
            src={download}
          />
            <div style={{ fontFamily: 'Inter-Medium', color: 'white', marginLeft: '5px' }}>Excel</div>
          </a>
        </div>

      </div>

      {/* BSI Intelligence Dropdown - above EOD Balance */}
      <BsiIntelligence
        userId={userId}
        appId={appId}
        source="onemoney"
      />
      <LoanRecyclingErrorBoundary userId={userId} appId={appId}>
        <LoanRecyclingCard userId={userId} appId={appId} />
      </LoanRecyclingErrorBoundary>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "2em",
          marginLeft: "1em",
        }}
      >
        <div
          style={{
            borderRadius: "1em",
            width: "50%",
            margin: "1em",
            boxShadow: "0px 0px 2px 2px  #f0f0f0",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "1em",
                width: "100%",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  fontFamily: "Outfit",
                }}
              >
                <img style={{ marginRight: "0.5em" }} src={averageEod} />
                Average EOD Balance
              </p>
            </div>
          </div>
          <div style={{ padding: "1em", paddingLeft: "2em", marginTop: "2em" }}>
            <Bar
              redraw={true}
              options={optionsVerticalBar}
              data={dataVertical}
            />
          </div>
        </div>
        <FraudCheck fraudDetails={displayData}/> 
      </div>
      <Accordion style={{ width: '95%', marginLeft: '2rem', marginTop: '1em' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header" sx={{ borderBottom: 'none' }}
        >
          <Typography component="span"> <img style={{ marginRight: "0.5em" }} src={credit5} /> Bounce Transactions ({displayData?.bounceTransactions?.length})</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead sx={{ backgroundColor: '#F6F9FF' }}>
                <TableRow>
                  <TableCell >Date</TableCell>
                  <TableCell align="center" color="red">Transaction Note</TableCell>
                  <TableCell align="center">Amount</TableCell>
                  <TableCell align="center">Description</TableCell>
                  <TableCell align="center">Transaction Type</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayData?.bounceTransactions?.length >= 1 ? (
                  <>
                    {displayData?.bounceTransactions.map((row, idx) => (
                      <TableRow

                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell scope="row">
                          {getDisplayDateAA(row, idx, displayData?.bounceTransactions, 'dateOfTransaction')}
                        </TableCell>
                        <TableCell align="center">{row.narration}</TableCell>
                        <TableCell align="center">{row.amount}</TableCell>
                        <TableCell align="center">{row?.categoryCode === "Summary" ? "Total" : row?.categoryCode}</TableCell>
                        <TableCell align="center">{row.type}</TableCell>
                      </TableRow>
                    ))}
                  </>
                ) : <TableRow
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell scope="row">
                    No Bounce Transactions
                  </TableCell>
                  <TableCell align="center">No Bounce Transactions</TableCell>
                  <TableCell align="center">No Bounce Transactions</TableCell>
                  <TableCell align="center">No Bounce Transactions</TableCell>
                  <TableCell align="center">No Bounce Transactions</TableCell>
                </TableRow>}

              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      <Accordion style={{ width: '95%', marginLeft: '2rem', marginTop: '1em' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header" sx={{ borderBottom: 'none' }}
        >
          <Typography component="span">
            <img style={{ marginRight: "0.5em" }} src={debit5} />
            Salary Profile ({salaryStats.count})
            {salaryStats.count > 0 && (
              <>
                {" - "}
                Max. Salary: {'₹' + formatNumberWithCommas(salaryStats.max.toLocaleString())}
                {"  |  "}
                Min. Salary: {'₹' + formatNumberWithCommas(salaryStats.min.toLocaleString())}
                {"  |  "}
                Avg. Salary: {'₹' + (Math.round(salaryStats.avg * 100) / 100).toLocaleString()}
              </>
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead sx={{ backgroundColor: '#F6F9FF' }}>
                <TableRow>
                  <TableCell >Date</TableCell>
                  <TableCell align="center" color="red">Transaction Note</TableCell>
                  <TableCell align="center">Amount</TableCell>
                  <TableCell align="center">Description</TableCell>
                  <TableCell align="center">Transaction Type</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayData?.salaryTransactions?.length >= 1 ? (
                  <>
                    {displayData?.salaryTransactions.map((row, idx) => (
                      <TableRow
                        key={idx}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell scope="row">
                          {getDisplayDateAA(row, idx, displayData?.salaryTransactions, 'dateOfTransaction')}
                        </TableCell>
                        <TableCell align="center">{row.narration}</TableCell>
                        <TableCell align="center">{row.amount}</TableCell>
                        <TableCell align="center">{row.category === "Summary" ? "Total" : row.category}</TableCell>
                        <TableCell align="center">{row.type}</TableCell>
                      </TableRow>
                    ))}
                  </>
                ) : <TableRow

                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell scope="row">
                    No Salary Transactions
                  </TableCell>
                  <TableCell align="center">No Salary Transactions</TableCell>
                  <TableCell align="center">No Salary Transactions</TableCell>
                  <TableCell align="center">No Salary Transactions</TableCell>
                  <TableCell align="center">No Salary Transactions</TableCell>
                </TableRow>}

              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      <Accordion style={{ width: '95%', marginLeft: '2rem', marginTop: '1em' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header" sx={{ borderBottom: 'none' }}
        >
          <Typography component="span"> <img style={{ marginRight: "0.5em", height: '1.5em' }} src={loans} /> Loan Profile (Debit : ({emiCount}) {lastThreeEmiTransactions.length > 0 && (
          <>
            {" "}-{" "}
            {lastThreeEmiTransactions.map((item, index) => (
              <Typography component="span" key={index}>
                {item.yearMonthForTotal} : {'₹' + (item.amount ? formatNumberWithCommas(item.amount) : 0)}
                {index !== lastThreeEmiTransactions.length - 1 && " | "}
              </Typography>
            ))}
          </>
        )})(Credit:{loanCount} )</Typography>
        </AccordionSummary>
        <div style={{ display: 'flex' }}>
          <div style={{ width: '50%' }}>
            <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '20px' }}>Transaction Type : Debit</p>
            <AccordionDetails>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 550 }} aria-label="simple table">
                  <TableHead sx={{ backgroundColor: '#F6F9FF' }}>
                    <TableRow>
                      <TableCell >Date</TableCell>
                      <TableCell align="center">Amount</TableCell>
                      <TableCell align="center">Category</TableCell>
                      <TableCell align="center" color="red">Transaction Note</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {displayData?.emiTransactions?.length >= 1 ? (
                      <>
                        {displayData?.emiTransactions.map((row, idx) => (
                          <TableRow

                            sx={{ '&:last-child td, &:last-child th': { border: 0 },bgcolor:row?.dateOfTransaction === "Total" ?"gray":null }}
                          >
                            <TableCell scope="row">
                              {getDisplayDateAA(row, idx, displayData?.emiTransactions, 'dateOfTransaction')}
                            </TableCell>
                            <TableCell align="center">{row.amount}</TableCell>
                            <TableCell align="center">{row.category === "Summary" ? "Total" : row.category}</TableCell>
                            <TableCell align="center">{row.narration}</TableCell>
                          </TableRow>
                        ))}
                      </>
                    ) : <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell scope="row">
                        No Loans
                      </TableCell>
                      <TableCell align="center">No Loans</TableCell>
                      <TableCell align="center">No Loans</TableCell>
                      <TableCell align="center">No Loans</TableCell>
                    </TableRow>}

                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </div>
          <div style={{ width: '50%' }}>
            <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '20px' }}>Transaction Type : Credit</p>
            <AccordionDetails>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 550 }} aria-label="simple table">
                  <TableHead sx={{ backgroundColor: '#F6F9FF' }}>
                    <TableRow>
                      <TableCell >Date</TableCell>
                      <TableCell align="center">Amount</TableCell>
                      <TableCell align="center">Category</TableCell>
                      <TableCell align="center" color="red">Transaction Note</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {displayData?.loanTransactions?.length >= 1 ? (
                      <>
                        {displayData?.loanTransactions.map((row, idx) => (
                          <TableRow

                            sx={{ '&:last-child td, &:last-child th': { border: 0 },bgcolor:row?.dateOfTransaction === "Total" ?"gray":null }}
                          >
                            <TableCell scope="row">
                              {getDisplayDateAA(row, idx, displayData?.loanTransactions, 'dateOfTransaction')}
                            </TableCell>
                            <TableCell align="center">{row.amount}</TableCell>
                            <TableCell align="center">{row.category === "Summary" ? "Total" : row.category}</TableCell>
                            <TableCell align="center">{row.narration}</TableCell>
                          </TableRow>
                        ))}
                      </>
                    ) : <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell scope="row">
                        No Loans
                      </TableCell>
                      <TableCell align="center">No Loans</TableCell>
                      <TableCell align="center">No Loans</TableCell>
                      <TableCell align="center">No Loans</TableCell>
                    </TableRow>}

                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </div>
        </div>
      </Accordion>
      
      <Accordion style={{ width: '95%', marginLeft: '2rem', marginTop: '1em' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header" sx={{ borderBottom: 'none' }}>
          <Typography component="span"> <img style={{ marginRight: "0.5em" }} src={frame} /> FOIR Summary</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Chart
            redraw={true}
            options={optionsFoir}
            type="bar"
            data={dataFoir}
          />
        </AccordionDetails>
      </Accordion>
        </>
      )}
      
    </div>
  );
}
